@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.item {
  @include sm-sohne;
}

.loadingItem {
  padding: 8px;
}
